import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AttendeeModel } from './attendee.model';

export class CopyEventModel {
  public eventId!: string;
  public fromCalendarId!: string;
  public toCalendarId!: string;
}
